import { buildXfinityClickOffUrl } from "@/lib/clickthrough-destination";
import type { StickyOfferBannerSlotData } from "./types";

export const defaultStickyOfferBannerData: StickyOfferBannerSlotData = {
  elementName: "StickyOfferBanner",
  backgroundColor: "transparent-dark",
  icon: {
    assetKey: "IconStopwatch",
  },
  title: {
    copy: "Get online in minutes with same-day WiFi",
  },
  subtitle: {
    copy: "Pick up in-store and self-install your WiFi in less than 15 minutes.",
  },
  ctaGroup: {
    orientation: "horizontal",
    alignment: "left",
    ctas: [
      {
        display: "fill",
        copy: "Shop internet",
        action: "link",
        url: buildXfinityClickOffUrl("/learn/offers"),
      },
    ],
  },
};
